module.exports = __webpack_public_path__ + "img/Resume-pic1.f8a840b4.png";